/* unplugin-vue-components disabled */import script from "./CoverUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverUploader.vue?vue&type=script&setup=true&lang=ts"

import "./CoverUploader.vue?vue&type=style&index=0&id=49c5af8e&lang=scss&scoped=true"
import "./CoverUploader.vue?vue&type=style&index=1&id=49c5af8e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c5af8e"]])

export default __exports__